module.exports = __webpack_public_path__ + "img/Latam_Dev.95f1b160.jpg";